<template>
  <v-card style="min-height: 300px; position: relative; height: 100%;">
    <v-overlay absolute :opacity="0.5" z-index="100000" v-if="loading">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
    <v-form class="user-settings">
      <v-toolbar
        flat
        dark
        :class="screen === 'mobile' ? '' : 'pr-5 pl-10'"
        color="#2196F3"
      >
        <span class="btn__icon mr-2">
          <svg width="27" height="23" fill="#fff" viewBox="0 0 27 23">
            <use xlink:href="#gear-icon" />
          </svg>
        </span>
        <v-toolbar-title>
          {{ $t("modals.userSettings.title") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('popup_close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container
        class="pt-5"
        :class="screen === 'mobile' ? '' : 'pr-10 pl-15 pt-0'"
      >
        <v-row>
          <v-col class="pt-0 popup__card">
            <v-card class="user-settings__card">
              <v-card-title class="user-settings__card-title pl-5">
                {{ $t("modals.userSettings.subtitle_1") }}
              </v-card-title>
              <v-card-text :class="screen === 'mobile' ? '' : 'pl-0 pr-0'">
                  <draggable
                    class="user-settings__drag-area"
                    :list="groupTypes.treeNodesOrder"
                    :group="{ dragGroupName: 'g1' }"
                  >
                    <v-checkbox
                      v-for="check in groupTypes.treeNodesOrder"
                      :class="
                        screen === 'mobile'
                          ? 'pr-5 pl-5 pt-2 pb-2'
                          : 'pr-5 pl-5 pt-2 pb-2'
                      "
                      :key="check.nodeType"
                      :label="$t(`modals.userSettings.type_${check.nodeType}`)"
                      color="#82b1ff"
                      v-model="check.isChecked"
                      hide-details
                    ></v-checkbox>
                  </draggable>
              </v-card-text>
            </v-card>
            <span class="caption"
              >{{$t('modals.userSettings.notice')}}</span
            >
          </v-col>
          <v-col class="pt-0 popup__card">
            <div class="user-settings__stories">
              <h3 class="user-settings__card-title">
                {{ $t("modals.userSettings.subtitle_2") }}
              </h3>
              <v-checkbox
                :label="$t('modals.userSettings.stories_label')"
                v-model="groupTypes.groupByTopics"
                color="#82b1ff"
                hide-details
              ></v-checkbox>
            </div>
            <div class="user-settings__time-shift">
              <h3 class="user-settings__card-title">
                {{ $t("modals.userSettings.subtitle_3") }}
              </h3>
              <v-select
                :items="timeShifts"
                label="Solo field"
                v-model="groupTypes.timeShift"
                solo
              ></v-select>
            </div>
          </v-col>
        </v-row>
        <v-tooltip z-index="1000" bottom>
          <template v-slot:activator="{ on, attrs }">
            <button
              class="btn btn--fill ml-auto user-settings__submit"
              v-bind="attrs"
              v-on="on"
              dark
              @click.prevent="sendUserSettings(), $emit('topics', groupTypes.groupByTopics)"
            >
              <span>{{ $t("modals.userSettings.apply") }}</span>
            </button>
          </template>
          <span>{{ $t("tooltips.applyUserSettings") }}</span>
        </v-tooltip>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
export default {
  name: "UserSettings",
  props: {
    screen: String,
    scrlSet: Object,
  },
  data: () => ({
    groupTypes: [],
    dragGroupName: "draggableArea",
    timeShifts: [3, 2, 1, 0, -1, -2, -3],
    loading: true,
  }),
  async mounted() {
    this.groupTypes = await this.$store.dispatch("getUserSettings");
    this.$emit('topics', this.groupTypes.groupByTopics)
    this.loading = false;
  },
  methods: {
    /**
     * get template obj by ID
     * */
    getTemplateById(id) {
      return this.docTypes.filter((type) => type.id === this.activeTemplate)[0];
    },
    /**
     * download file func
     * */
    getArticlesId() {
      return this.articles.map((article) => article.id);
    },
    async sendUserSettings() {
      let isHaveSelection = this.groupTypes.treeNodesOrder.filter(
        (group) => group.isChecked === true
      );
      if (isHaveSelection.length === 0) {
        return this.$toastr.warning(this.$t("messages.selectGroup"));
      }

      this.loading = true;
      let data = {
        settings: {
          groupByTopics: this.groupTypes.groupByTopics,
          treeNodesOrder: this.groupTypes.treeNodesOrder,
        },
      };
      await this.$store.dispatch("saveUserSettings", data);
      this.loading = false;
      this.$emit("reload");
      this.$emit("popup_close");
    },
  },
};
</script>
<style lang="scss">
.sortable-chosen {
  background: #e3f3ff;
}

.user-settings {
  background: #fff;
  .v-card__title {
    font-size: 14px;
    line-height: 16px;
    color: #757575;
    border-bottom: 1px solid #e8e8e8;
  }
  .caption,
  &__card-title {
    font-size: 14px !important;
    line-height: 16px;
    color: #757575;
    font-weight: 500;
  }
  &__card-title {
    margin-bottom: 10px;
    & + .v-input--selection-controls.v-input {
      margin: 0;
    }
  }
  &__stories {
    margin-bottom: 30px;
  }
  &__drag-area {
    .v-input--selection-controls.v-input {
      margin: 0;
    }
  }
  &__submit {
    position: absolute;
    bottom: 20px;
    right: 40px;
    @media (max-width: 1280px) {
      position: static;
    }
  }
}
</style>